const loadingImg = require('@a/image/docu_list_icon_default@2x.png');
const errorImg = require('@a/image/file_image_failed@2x.png');
// url中folderId中的分隔符
const pathSeparator = '&&';
// 根folderId
const rootFolderId = '';

// 全局的一些样式
const globalCssStyle = {
  // contextMenu组件相关
  menuWidth: 150,
  menuItemHeight: 32,
  menuPadding: 24
};


let baseURL;  // 请求前缀
let redirectMobileURL;   // 重定向到移动端的前缀
if (/elfinbook\.com/.test(window.location.href)) {
  baseURL = '//api.elfinbook.com';
  redirectMobileURL = '//app.elfinbook.com/webapp'
} else if (/localhost/.test(window.location.href)) {
  baseURL = 'http://localhost:9000';
} else {
  baseURL = '//api.elfinbook.test.hzqihui.cn';
  // baseURL = '//api.book.com';
  redirectMobileURL = '//m.elfinbook.test.hzqihui.cn/webapp'
}




export { loadingImg, errorImg, pathSeparator, rootFolderId, globalCssStyle, baseURL, redirectMobileURL };
